import { render } from "./ListMenuset.vue?vue&type=template&id=07a647ea&scoped=true"
import script from "./ListMenuset.vue?vue&type=script&lang=js"
export * from "./ListMenuset.vue?vue&type=script&lang=js"

import "./ListMenuset.vue?vue&type=style&index=0&id=07a647ea&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a647ea"]])

export default __exports__